"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
function normalizeSuggestionSelection(suggestion) {
    var searchHash = 'filters' in suggestion
        ? (0, utils_1.encodeAndStringify)({
            filters: suggestion.filters
        })
        : suggestion.searchHash;
    return {
        buildKey: 'buildKey' in suggestion ? suggestion.buildKey : null,
        highlightedText: suggestion.highlightedText,
        href: 'href' in suggestion
            ? suggestion.href
            : "/cars/filters?cvnaid=".concat(searchHash),
        searchHash: searchHash,
        searchType: suggestion.searchType,
        text: suggestion.text
    };
}
exports.default = normalizeSuggestionSelection;
//# sourceMappingURL=normalizeSuggestionSelection.js.map